import React, { useState } from "react"
import { ReactSVG } from "react-svg"

import * as styles from "./filter.module.scss"
import Button from "../../../../components/common/jsx/button/button"
import useWindowWidth from "../../../../hooks/use-window-width"
import downArrow from "../../../../../static/vectors/downArrow.svg"
import { DatoCmsArticle } from "../../../../../graphql-types"

type FilterProps = {
  projectsNewsInsightsAllFilter: boolean
  projectsNewsInsightsFilterLabel: string
  projectsNewsInsightsTwoFilters: Array<any>
  articles: Array<DatoCmsArticle>
  filterArticles: any
  color?: string
  changeCurrentPage?: any
}

const Filter: React.FC<FilterProps> = ({
  projectsNewsInsightsAllFilter,
  projectsNewsInsightsFilterLabel,
  projectsNewsInsightsTwoFilters,
  filterArticles,
  articles,
  color,
  changeCurrentPage,
}) => {
  const [isFilterSelected, setIsFilterSelected] = useState(projectsNewsInsightsAllFilter)
  const [selectedFilterName, setSelectedFilterName] = useState(projectsNewsInsightsFilterLabel || undefined)

  const displayDesktopFilters = (): JSX.Element => {
    return (
      <section className={styles.container}>
        {projectsNewsInsightsAllFilter && (
          <div className={styles.buttonContainer}>
            <Button
              data={{ title: `${projectsNewsInsightsFilterLabel}` }}
              isFilterButton={true}
              isFilterSelected={isFilterSelected && projectsNewsInsightsFilterLabel === selectedFilterName}
              disabled={isFilterSelected && projectsNewsInsightsFilterLabel === selectedFilterName}
              onClick={() => handleAllFilterSelection(projectsNewsInsightsFilterLabel)}
            />
          </div>
        )}
        {projectsNewsInsightsTwoFilters.map((filter, index) => (
          <div key={index} className={styles.buttonContainer}>
            <Button
              data={{ title: `${filter.label}` }}
              isFilterButton={true}
              isFilterSelected={isFilterSelected && filter.label === selectedFilterName}
              disabled={isFilterSelected && filter.label === selectedFilterName}
              onClick={() => handleFilterSelection(filter.label)}
            />
          </div>
        ))}
      </section>
    )
  }

  /**
   * Handle filter selection when it's not ALL articles filter.
   * @param filterName
   */
  const handleFilterSelection = (filterName): void => {
    setSelectedFilterName(filterName)
    setIsFilterSelected(true)

    const filteredArticles: Array<DatoCmsArticle> = []
    articles.forEach(article => {
      if (article.category.label === filterName) {
        filteredArticles.push(article)
      }
    })
    filterArticles(filteredArticles)
    if (changeCurrentPage) changeCurrentPage(1)
  }

  /**
   * Handle ALL filter selection
   * @param filterName
   */
  const handleAllFilterSelection = (filterName): void => {
    setSelectedFilterName(filterName)
    setIsFilterSelected(true)

    filterArticles(articles)
  }

  return <div>{displayDesktopFilters()}</div>
}

export default Filter
